import clsx from "clsx";
import { ReactNode } from "react";
import { useState } from "react";
import EyeFill from "../Icons/EyeFill";
import EyeFillInvisible from "../Icons/EyeFillInvisible";
import UploadIcon from "../Icons/UploadIcon";
import CalendarIcon from "../Icons/CalendarIcon";
export type inputProps = {
  title?: string;
  className?: string;
  placeholder?: string;
  disabled?: boolean;
  name: string;
  isControlled?: boolean;
  isRequired?: boolean;
  children?: ReactNode;
  value?: string;
  type?: string;
  inputStyles?: string;
  error?:string;
  isCode?: boolean;
  upload?: boolean;
  date?:boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ref?:any;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
};

const Input = ({
  title,
  className,
  placeholder,
  name,
  disabled = false,
  isControlled = true,
  onChange,
  onBlur,
  children,
  value,
  type,
  error,
  date = false,
  inputStyles,
  isCode,
  upload = false,
  ref
}: inputProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const isPassword = type === "password" ? true : false;
  const styles = clsx(
    "border-2 border-black border-opacity-40 block w-full p-4 focus:outline-none hover:border-primary hover:border-opacity-100 transition-all ease-in focus:border-secondary focus:ring-secondary/50 rounded-lg h-16 sm:text-base text-sm",
    disabled ? "opacity-50" : ""
  );
  return (
    <div className={`md:space-y-2 space-y-1.5 relative font-medium ${className}`}>
      {title &&
      <label htmlFor={name} className="text-burntBlack md:text-base text-sm">
        {title}
      </label>
      }
      {isControlled ? (
        <div className="relative">
          <div className="absolute right-5 top-1/2 -translate-y-1/2">
          {date && <CalendarIcon/>}
          {upload && <UploadIcon height={30} width={30}/>}
            {isPassword && (
              <i
                onClick={disabled ? undefined : handleShowPassword}
                className={`input_group__container__icon  ${
                  disabled ? "input_group__container__icon--disabled" : ""
                }`}
              >
                
                {showPassword ? <EyeFill /> : <EyeFillInvisible />}
              </i>
            )}

            {children}
          </div>
          <input
            type={
              isPassword && showPassword
                ? "text"
                : isPassword
                ? "password"
                : type
            }
            onChange={onChange}
            onBlur={onBlur}
            value={value}
            ref={ref}
            className={`${styles} ${inputStyles}`}
            placeholder={placeholder}
            disabled={disabled}
            name={name}
            min={0}
            maxLength={isCode ? 1 : undefined}
          />
        </div>
      ) : (
        <div className="relative">
          <div className="absolute right-5 top-1/2 -translate-y-1/2">
            {children}
          </div>
          <input
            className={styles}
            placeholder={placeholder}
            disabled={disabled}
          />
        </div>
      )}
            {error && <span className={`text-red-500 sm:text-base text-xs ${isCode ? 'text-[10px] absolute left-1/2 w-full -translate-x-1/2' : ''} `}>{error}</span>}

    </div>
  );
};

export default Input;
